/**
 * announcement-delivery-countdown.js  (v3 — fix timing de geolocalización tardía)
 * Integra coverage-gam.js con el primer slide del announcement_bar_slider.
 *
 * Opción A: reescribe el contenido del PRIMER mensaje del slider segun la
 * cobertura same-day geolocalizada del visitante. Si no hay ubicacion
 * (estado 'generico'), NO toca el slide: queda el mensaje configurado en el theme editor.
 *
 * Requiere que coverage-gam.js se cargue ANTES que este archivo.
 *
 * CAMBIOS v3:
 *   - Fix race condition: en sesiones nuevas, el prompt de geolocalización del
 *     navegador es asíncrono. my-store-locator.js escribe la cookie
 *     'location_position' recién cuando el usuario ACEPTA, lo que ocurre DESPUÉS
 *     del primer aplicar(). Antes el slide quedaba en el mensaje genérico para
 *     siempre. Ahora, si el estado inicial es 'generico', se hace un polling
 *     corto vigilando la aparición de la cookie y se re-aplica al detectarla.
 *     También escucha un evento opcional 'ishop:location-ready' por si el
 *     locator lo emite en el futuro (red de seguridad de cero costo).
 *   - Detección de cruce de umbral por estado interno (data-delivery-mode) en
 *     vez de inspeccionar el texto, robusta ante cambios de copy.
 *
 * Configuración (opcional) vía window.ANNOUNCEMENT_CONFIG:
 *   - umbralCountdownHoras, umbralUltimaHoraHoras
 *   - txtBeneficioHoy, txtCountdown, txtCountdownUrgente, txtManana, txtFuera, txtRetiro
 * Si no hay config, se usan los defaults históricos.
 *
 * Matriz de mensajes (cobertura x tiempo):
 *   en zona, faltan > umbral        -> beneficio sin numeros
 *   en zona, faltan <= umbral y > 1h-> countdown "Quedan Xh Ym para recibirlo hoy"
 *   en zona, ultima hora (<= 1h)    -> countdown con copy mas urgente
 *   en zona, pasado corte/dom/fer   -> "Recibilo MANANA en tu zona"
 *   fuera de zona                   -> "Entrega a domicilio en 2 dias habiles"
 *   sin ubicacion                   -> no se modifica
 */
(function () {
  'use strict';

  var CFG = window.ANNOUNCEMENT_CONFIG || {};

  function num(v, def) {
    var n = parseFloat(v);
    return isFinite(n) ? n : def;
  }
  function txt(v, def) {
    return (typeof v === 'string' && v.length) ? v : def;
  }

  // Umbrales en segundos (config en horas, fallback 4h / 1h).
  var UMBRAL_COUNTDOWN   = num(CFG.umbralCountdownHoras, 4) * 3600;
  var UMBRAL_ULTIMA_HORA = num(CFG.umbralUltimaHoraHoras, 1) * 3600;

  // Días hábiles fuera de zona (para el placeholder {numero_de_dias} del texto).
  var DIAS_FUERA = num(CFG.diasEntregaFuera, 2);

  var TXT = {
    beneficioHoy:     txt(CFG.txtBeneficioHoy,     'Recibilo HOY si comprás antes de las {hora}'),
    countdown:        txt(CFG.txtCountdown,        'Quedan {cd} para recibirlo HOY'),
    countdownUrgente: txt(CFG.txtCountdownUrgente, 'Últimos {cd} para recibirlo HOY'),
    manana:           txt(CFG.txtManana,           'Recibilo {label} en tu zona de cobertura'),
    fuera:            txt(CFG.txtFuera,            'Entrega a domicilio en 2 días hábiles'),
    retiro:           txt(CFG.txtRetiro,           ' · Retiro en tienda en 1h')
  };

  var SLIDE_SEL = '#shopify-section-announcement_bar_slider .hura-message';
  var MARK = 'data-delivery-dynamic';
  var MODE = 'data-delivery-mode';   // 'beneficio' | 'countdown' | 'urgente' | 'manana' | 'fuera'

  function fmtHora(h) {
    var ampm = h >= 12 ? 'pm' : 'am';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + ':00' + ampm;
  }

  function fmtCountdown(segs) {
    if (segs < 0) segs = 0;
    var h = Math.floor(segs / 3600);
    var m = Math.floor((segs % 3600) / 60);
    var s = segs % 60;
    if (h > 0) return h + 'h ' + (m < 10 ? '0' : '') + m + 'm';
    if (m > 0) return m + 'm ' + (s < 10 ? '0' : '') + s + 's';
    return s + 's';
  }

  // Devuelve { html, mode } para poder guardar el modo sin parsear el texto.
  function construir(d) {
    if (d.estado === 'hoy') {
      if (d.segundosRestantes > UMBRAL_COUNTDOWN) {
        return { html: TXT.beneficioHoy.replace('{hora}', fmtHora(d.corteHora)) + TXT.retiro, mode: 'beneficio' };
      }
      var urgente = d.segundosRestantes <= UMBRAL_ULTIMA_HORA;
      var plantilla = urgente ? TXT.countdownUrgente : TXT.countdown;
      return {
        html: plantilla.replace('{cd}', '<span class="js-delivery-cd">' + fmtCountdown(d.segundosRestantes) + '</span>') + TXT.retiro,
        mode: urgente ? 'urgente' : 'countdown'
      };
    }
    if (d.estado === 'manana') {
      return { html: TXT.manana.replace('{label}', '<strong>' + (d.label || 'MAÑANA') + '</strong>') + TXT.retiro, mode: 'manana' };
    }
    if (d.estado === 'fuera') {
      return { html: TXT.fuera.replace('{numero_de_dias}', DIAS_FUERA) + TXT.retiro, mode: 'fuera' };
    }
    return null;
  }

  var cdTimer = null;

  function aplicar(slide) {
    if (!window.iShopCoverage) return;
    var d = window.iShopCoverage.detalle();
    var built = construir(d);

    // Estado 'generico' (sin ubicación): restaurar el original si lo habíamos tocado.
    if (built === null) {
      if (slide.getAttribute(MARK) === '1' && slide._origHTML != null) {
        slide.innerHTML = slide._origHTML;
        slide.removeAttribute(MARK);
        slide.removeAttribute(MODE);
      }
      if (cdTimer) { clearInterval(cdTimer); cdTimer = null; }
      return;
    }

    if (slide._origHTML == null) slide._origHTML = slide.innerHTML;
    slide.innerHTML = built.html;
    slide.setAttribute(MARK, '1');
    slide.setAttribute(MODE, built.mode);

    if (cdTimer) { clearInterval(cdTimer); cdTimer = null; }

    // Solo corre timer si hay un countdown visible (estado hoy dentro del umbral).
    if (d.estado === 'hoy' && d.segundosRestantes <= UMBRAL_COUNTDOWN) {
      var fin = Date.now() + d.segundosRestantes * 1000;
      cdTimer = setInterval(function () {
        var restan = Math.round((fin - Date.now()) / 1000);
        if (restan <= 0) {
          clearInterval(cdTimer); cdTimer = null;
          aplicar(slide);                       // recalcula -> pasa a 'manana'
          return;
        }
        // Cruce a copy urgente: comparar contra el MODO guardado, no contra el texto.
        var modoActual = slide.getAttribute(MODE);
        if (restan <= UMBRAL_ULTIMA_HORA && modoActual !== 'urgente') {
          aplicar(slide);                       // recompone el copy completo
          return;
        }
        var cd = slide.querySelector('.js-delivery-cd');
        if (cd) cd.textContent = fmtCountdown(restan);
      }, 1000);
    }
  }

  // --------------------------------------------------------------------------
  // Fix timing: vigilar la aparición tardía de la ubicación.
  // El prompt de geolocalización es asíncrono; la cookie 'location_position'
  // (o un preferredStoreId) puede aparecer DESPUÉS del primer aplicar().
  // --------------------------------------------------------------------------
  function hayUbicacion() {
    try {
      if (window.localStorage && localStorage.getItem('preferredStoreId')) return true;
    } catch (e) {}
    return document.cookie.indexOf('location_position=') !== -1;
  }

  function vigilarUbicacion(slide) {
    // Si ya hay ubicación, no hace falta vigilar (el aplicar() inicial ya la usó).
    if (hayUbicacion()) return;

    var intentos = 0;
    var MAX_INTENTOS = 24;          // 24 * 500ms = 12s, cubre el tiempo de decisión del prompt
    var iv = setInterval(function () {
      intentos++;
      if (hayUbicacion()) {
        clearInterval(iv);
        aplicar(slide);             // la ubicación llegó: reescribir el slide
      } else if (intentos >= MAX_INTENTOS) {
        clearInterval(iv);          // el usuario no aceptó / no hay GPS: queda el genérico
      }
    }, 500);

    // Red de seguridad: si el locator algún día emite este evento al escribir
    // la cookie, reaccionamos al instante y dejamos de pollear.
    document.addEventListener('ishop:location-ready', function onReady() {
      clearInterval(iv);
      document.removeEventListener('ishop:location-ready', onReady);
      aplicar(slide);
    });
  }

  function init() {
    var slide = document.querySelector(SLIDE_SEL);
    if (!slide) return false;
    aplicar(slide);
    vigilarUbicacion(slide);        // <-- clave del fix
    return true;
  }

  function start() {
    if (init()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (init() || tries > 40) clearInterval(iv);
    }, 250);

    // Reaccionar a la selección manual de tienda (intención explícita del usuario).
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.js-make-my-store-btn, .js-store-locator-select-btn')) {
        setTimeout(function () {
          var s = document.querySelector(SLIDE_SEL);
          if (s) aplicar(s);
        }, 600);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();